/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import {
    string, func, object, oneOfType, shape, elementType, number, arrayOf,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PersonalizeImageCustoms from './PersonalizeImageCustoms';
import PersonalizeMessageCustoms from './PersonalizeMessageCustoms';
import PersonalizeImageAndMessageCustoms from './PersonalizeImageAndMessageCustoms';
import CustomsCardWrapper from '../CustomsCardWrapper/CustomsCardWrapper';

const styles = (theme) => ({
    saveButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '30px 0',
        [theme.breakpoints.down('xs')]: {
            marginTop: 80,
            justifyContent: 'center',
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: 190,
        },
    },
    button: {
        padding: '6px 20px',
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
        },
        '@media screen and (min-width: 960px)': {
            marginRight: 10,
        },
    },
    selectCustomsContainer: {
        margin: '30px 0px',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            margin: '15px 0px',
        },
    },
    changeImage: {
        textAlign: 'center',
        marginTop: '10px',
        marginLeft: 'calc(50% - 64px)',
        '& span': {
            cursor: 'pointer',
            padding: '8px 10px',
            background: '#000',
            color: '#fff',
            borderRadius: '20px',
        },
    },
});
const CUSTOM_VIEWS = {
    SELECT_IMAGE: 'photo',
    SELECT_MESSAGE: 'text',
    SELECT_IMAGE_AND_MESSAGE: 'both',
};
const SelectCustoms = ({
    classes,
    customsCard,
    customCardType,
    image,
    message,
    setImage,
    setMessage,
    personalizeCustomsCard,
    customCardStyling,
    imagePreviewCanvasRef,
    handleImage,
    customData,
    customType,
    toolsFontData,
}) => {
    const contentAreaWidth = customData?.content_area_width;
    const conentAreaHeight  = customData?.content_area_height;
    const contentImageAreaWidth = customData?.message_image_settings?.image_width;
    let response = null;
    const isValidCard = (customCardType === CUSTOM_VIEWS.SELECT_IMAGE_AND_MESSAGE && image && message?.text?.trim()?.length > 0) ||  (customCardType === CUSTOM_VIEWS.SELECT_MESSAGE && message?.text?.trim()?.length > 0) || (customCardType === CUSTOM_VIEWS.SELECT_IMAGE && image);
    response = (
        <>
            <Grid item sm={12} xs={12} className={classes.selectCustomsContainer}>
                <CustomsCardWrapper customsCard={customsCard} customType={customType} customData={customData}>
                    {customCardType === CUSTOM_VIEWS.SELECT_IMAGE
                && (
                    <PersonalizeImageCustoms
                        image={image}
                        setImage={setImage}
                        handleImage={handleImage}
                        imgWidth={contentAreaWidth}
                        imgHeight={conentAreaHeight}
                        imagePreviewCanvasRef={imagePreviewCanvasRef}
                    />
                )}
                    {customCardType === CUSTOM_VIEWS.SELECT_MESSAGE
                && (
                    <PersonalizeMessageCustoms
                        message={message}
                        setMessage={setMessage}
                        csLabelData={customData}
                        toolbarProps={toolsFontData}
                        customCardType={customCardType}
                    />
                )}
                    {customCardType === CUSTOM_VIEWS.SELECT_IMAGE_AND_MESSAGE
                && (
                    <PersonalizeImageAndMessageCustoms
                        image={image}
                        handleImage={handleImage}
                        message={message}
                        setImage={setImage}
                        setMessage={setMessage}
                        imgWidth={contentImageAreaWidth}
                        imgHeight={conentAreaHeight}
                        customCardStyling={customCardStyling}
                        imagePreviewCanvasRef={imagePreviewCanvasRef}
                        csLabelData={customData}
                        toolbarProps={toolsFontData}
                        customCardType={customCardType}
                    />
                )}
                </CustomsCardWrapper>
            </Grid>
            {image  && (
                <div className={classes.changeImage}>
                    <span role="presentation" onClick={() => setImage('')}>Change Image</span>
                </div>
            )}
            <Grid item xs={12} className={classes.saveButton}>
                <Button variant="contained" color="primary" className={classes.button} onClick={personalizeCustomsCard} disabled={!isValidCard}>{customType === 'label' ? 'Review Label' : 'Review Hangtag'}</Button>
            </Grid>
        </>
    );
    return response;
};

SelectCustoms.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    customCardType: string.isRequired,
    image: string.isRequired,
    message: object.isRequired,
    setImage: func.isRequired,
    setMessage: func.isRequired,
    personalizeCustomsCard: func.isRequired,
    customCardStyling: shape({
        image_width: number.isRequired,
        message_width: number.isRequired,
        space_between_message_image: number.isRequired,
    }).isRequired,
    handleImage: func.isRequired,
    imagePreviewCanvasRef: oneOfType([
        func,
        shape({ current: elementType }),
    ]).isRequired,
    customData: shape({
        content_area_width: number,
        content_area_height: number,
        message_image_settings: shape({
            image_width: number,
        }),
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
    toolsFontData: arrayOf(shape({
        value: string,
        label: string,
        icon: object,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
};

export default withStyles(styles)(SelectCustoms);
